(function () {
  function initSlider(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.bruku-slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.bruku-slider-dot'));
    var prevBtn = root.querySelector('.bruku-slider-arrow--prev');
    var nextBtn = root.querySelector('.bruku-slider-arrow--next');
    if (slides.length < 2) return;

    var current = 0;
    var speed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 5000;
    var autoplayEnabled = root.getAttribute('data-autoplay') === 'true';
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null;

    function goTo(index) {
      index = (index + slides.length) % slides.length;
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = index;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      if (!autoplayEnabled || reduceMotion) return;
      stopAutoplay();
      timer = setInterval(next, speed);
    }
    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); startAutoplay(); });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', startAutoplay);

    // Swipe tactil: en movil las flechas laterales se ocultan via CSS, asi
    // que la navegacion del carrusel depende de que el usuario pueda
    // deslizar el dedo para cambiar de slide.
    var touchStartX = null;
    var touchStartY = null;
    var track = root.querySelector('.bruku-slider-track');
    if (track) {
      track.addEventListener('touchstart', function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        stopAutoplay();
      }, { passive: true });

      track.addEventListener('touchend', function (e) {
        if (touchStartX === null) return;
        var touch = e.changedTouches && e.changedTouches[0];
        if (touch) {
          var deltaX = touch.clientX - touchStartX;
          var deltaY = touch.clientY - touchStartY;
          // Solo se interpreta como swipe horizontal si el movimiento lateral
          // es claramente mayor que el vertical (para no interferir con el
          // scroll normal de la pagina) y supera un umbral minimo.
          if (Math.abs(deltaX) > 40 && Math.abs(deltaX) > Math.abs(deltaY)) {
            if (deltaX < 0) { next(); } else { prev(); }
          }
        }
        touchStartX = null;
        touchStartY = null;
        startAutoplay();
      });
    }

    startAutoplay();
  }

  function init() {
    document.querySelectorAll('.bruku-slider').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
